import {Spin} from "antd";


function Spinner() {

    return (<div className="fixed inset-0 flex items-center justify-center">
        <Spin size="large"/>
    </div>);
}

export default Spinner;
